export default __webpack_public_path__ + "static/media/serviceparts.57017af9.png";